import { observable, computed, action, transaction, toJS } from 'mobx'
import UploadState from './upload'
import omit from 'lodash/omit'

export default class ArrayAttrsState extends UploadState {
  @action
  changeAttrArrayValue (attr, whereCond, value, rec = null) {
    const attrs = rec || this.cv.record.get(attr) || []
    const found = attrs.find((i) => {
      for (const k in whereCond) {
        if (k === 'lang' && !whereCond[k]) {
          whereCond[k] = null
        }
        if (i[k] !== whereCond[k]) {
          return false
        }
      }
      return true
    })
    if (!found) { // it is not in attr array -> push it there
      attrs.push(Object.assign({ value }, whereCond))
    } else {
      found.value = value // just update found row
      found.updated = new Date()
    }
    !rec && this.cv.runGlobalValidator()
  }

  @action
  addValueToTagArray (tagName, value) {
    const tagValue = { enum_value: value }
    const found = this.cv.record.get(tagName).find((i) => (i.enum_value === value))
    if (!found) { // not to make duplicities
      this.cv.record.get(tagName).push(tagValue)
    }
  }

  @action
  removeArrayRow (attr, row, rec = null) {
    const val = rec || this.cv.record.get(attr) || []
    val.remove(row)
    !rec && this.cv.runGlobalValidator()
  }

  @action
  addArrayRow (attr, row, rec = null) {
    const val = rec || this.cv.record.get(attr) || []
    val.push(row)
    !rec && this.cv.runGlobalValidator()
  }

  createEmbededEntityState (opts) {
    const s = Object.assign({
      showForm: false,
      record: observable.map({}),
      errors: observable.map({}),
      edited: null,
      _sortDir: 'ASC',
      defaultSort: {
        _sortField: opts._sortField || '',
        _sortDir: opts._sortDir || 'ASC'
      }
    }, opts)
    const o = observable(omit(s, ['attrs', 'titles']))
    o.attrs = s.attrs
    o.titles = s.titles
    return o
  }

  onSubentityEdit (state, items, row, extraParam = null) {
    if (this.cv.temporary) {
      for (const k of this.cv.temporary.keys()) {
        this.cv.temporary.delete(k)
      }
    }
    if (this.cv) {
      this.cv.modalIsOpen = true
    }
    state.edited = row
    state.platformFilter = null
    state.showForm = true

    transaction(() => {
      state.record.clear()
      if (state.edited) {
        state.record.merge(state.edited)
      } else {
        state.initVals && state.record.merge(state.initVals(row))
        if (extraParam !== undefined && extraParam !== null) {
          state.record.set('extraParam', extraParam)
        }
      }
      this._runSubentityValidators(state)
      this._runSubentityGlobalValidator(state, items)
    })
  }

  _runSubentityValidators (state) {
    const validators = (state && state.validators) || {}
    for (const fieldName in validators) {
      const value = state.record.get(fieldName)
      const fieldValidator = validators[fieldName]
      fieldValidator && (fieldName !== '_global') &&
        this._validateSubentityField(fieldName, value, fieldValidator, state)
    }
  }

  _runValidateArray (validatorArray, value, record) {
    let validatorFn, error, i
    for (i = 0; i < validatorArray.length; i++) {
      validatorFn = validatorArray[i]
      error = validatorFn(value, record)
      if (error !== undefined) {
        return error
      }
    }
  }

  _validateSubentityField (fieldName, value, validatorFn, state) {
    const error = validatorFn.call === undefined
      ? this._runValidateArray(validatorFn, value, state.record)
      : validatorFn(value, state.errors)
    if (error === undefined && state.errors.has(fieldName)) {
      state.errors.delete(fieldName)
    } else if (error !== undefined) {
      state.errors.set(fieldName, error)
    }
  }

  _runSubentityGlobalValidator (state, items) {
    const validators = (state && state.validators) || {}
    if (validators && validators._global) {
      const error = validators._global(state.record, items)
      if (error === undefined && state.errors.has('_global')) {
        state.errors.delete('_global')
      } else if (error !== undefined) {
        state.errors.set('_global', error)
      }
    }
  }

  handleSubentityFormClose (state) {
    state.showForm = false
    if (this.cv) {
      this.cv.modalIsOpen = false
    }
  }

  handleSubentityFormSubmit (state, items, onAddRow, onUpdateRow) {
    transaction(() => {
      const rec = Object.fromEntries(state.record)

      state.hasOwnProperty('lastSave') && this.saveLastSavedSubentity(state)

      function _defaultOnUpdateRow () {
        rec.updated = new Date() // set updated flag !!!!!!!!!!!!!!!
        rec.updated_at = new Date()
        rec.updatedAt = new Date()
        Object.assign(state.edited, rec)
      }
      if (state.edited) {
        onUpdateRow ? onUpdateRow(rec, state.edited) : _defaultOnUpdateRow()
      } else {
        onAddRow ? onAddRow(rec) : items.push(rec)
      }
      state.showForm = false
      if (this.cv) {
        this.cv.modalIsOpen = false
      }

      const _runClassValidators = () => {
        if (this.cv && (typeof this.cv._runValidators === 'function')) {
          return this.cv._runValidators()
        } else if (this.cv && this.cv.validators && this.cv.validators._global) {
          const error = this.cv.validators._global(state.record, items)
          if (error) {
            this.cv.errors.set('_global', [error])
          } else {
            this.cv.errors.delete('_global')
          }
        }
        if (this.cv.currBatchStore && this.cv.currBatchStore.runValidators) {
          this.cv.currBatchStore.runValidators()
        }
      }
      state.parent
        ? this._runSubentityGlobalValidator(state.parent, items)
        : _runClassValidators()
    })
  }

  @computed get eng_title () {
    try {
      const enTitle = this.cv.record.get('attrs').find((i) => {
        return i.platform === 'common' && i.name === 'name' && i.lang === 'en'
      })
      return enTitle.value
    } catch (e) {
      return ''
    }
  }

  @action
  updateSubentityField (state, items, name, value) {
    value = ((value !== undefined && value !== null) && value.toString().length > 0) ? value : null
    state.record.set(name, value)
    state.onFieldChange && state.onFieldChange[name] && state.onFieldChange[name](value, state)
    this._runSubentityValidators(state)
    this._runSubentityGlobalValidator(state, items)
  }

  onSubentitySort (state, sortField, sortDir, items) {
    const sortFields = state._sortField ? state._sortField.split(',') : []
    const sortDirs = state._sortDir ? state._sortDir.split(',') : []
    const sortStateIdx = sortFields.indexOf(sortField)
    if (sortStateIdx >= 0 && sortDir) {
      sortDirs[sortStateIdx] = sortDir
    } else if (sortStateIdx >= 0 && sortDir === null) {
      sortFields.splice(sortStateIdx, 1)
      sortDirs.splice(sortStateIdx, 1)
    } else {
      sortFields.push(sortField)
      sortDirs.push(sortDir)
    }
    transaction(() => {
      state._sortField = sortFields.join(',')
      state._sortDir = sortDirs.join(',')
    })
  }

  @action
  removeSubentity (items, attr, row, onRemoveRow) {
    onRemoveRow ? onRemoveRow(row) : items.remove(row)
    this.cv._runValidators && this.cv._runValidators()
    this.cv.runValidators && this.cv.runValidators()
  }
}
